import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {gsap} from "gsap";
import {SimplePresentation, SimplePresentationRunner} from "../../core/winpresentation/SimplePresentationRunner";
import {ReelStopRunner} from "../presentationRunner/ReelStopRunner";
import {FireFrameRunner} from "../presentationRunner/FireFrameRunner";

export class NormalResultPresentation implements FlowStatePresentation {
    private readonly _presentations: SimplePresentation[];

    constructor() {
        this._presentations = [
            new FireFrameRunner(),
            new ReelStopRunner(),
        ];
    }

    public start(flowStateController: FlowStateController) {
        SimplePresentationRunner.run(this._presentations, () => this.completePresentation(flowStateController), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }

    private completePresentation(flowStateController: FlowStateController) {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => {
            flowStateController.finish();
        });
    }
}